<template lang="html">
  <div class="login-main" @keyup.enter="onSubmit()">
    <img src="../../assets/images/entrance-logo.png" alt="">
    <el-form ref="rulesForm" :model="form" :rules="rules" label-width="100%" label-position="top">
      <el-form-item :label="message.email" style="text-align:left" prop="email" auto-complete="off">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item :label="message.identifying" style="text-align:left" prop="identifying">
        <el-col :span="8">
          <el-input v-model="form.identifying"></el-input>
        </el-col>
        <el-col :span="4">&nbsp;</el-col>
        <el-col :span="12">
          <div class="identifying-main" @click="getIdentifying()">
            <img class="identifying-img" :src="identifyingUrl" alt="">
          </div>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="width:100%;margin-top:10px" @click="onSubmit">{{ message.submit }}</el-button>
      </el-form-item>
    </el-form>
    <div class="login-register" @click="toLogin()">
      {{ message.login }}>>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    var checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l100))
      } else {
        callback()
      }
    }
    var checkIdentifying = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l104))
      } else {
        callback()
      }
    }
    return {
      message: {
        login: this.$lang.ui.form.login,
        email: this.$lang.ui.form.email,
        submit: this.$lang.ui.form.submit,
        identifying: this.$lang.ui.form.identifying
      },
      identifyingUrl: '',
      form: {
        email: '',
        identifying: '',
        identifyingId: ''
      },
      rules: {
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ],
        identifying: [
          { validator: checkIdentifying, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.getIdentifying()
  },
  methods: {
    toLogin () {
      this.$router.push({ path: '/app/login' })
    },
    getIdentifying () {
      this.$http.get('/cydex/api/v1/captcha')
        .then(response => {
          this.identifyingUrl = response.data.pic_url
          this.form.identifyingId = response.data.captcha_id
        })
    },
    onSubmit () {
      this.$refs['rulesForm'].validate((valid) => {
        if (valid) {
          this.$http.post('/cydex/api/v1/password_reset_apply', {
            'email': this.form.email,
            'auth_token': this.form.identifyingId,
            'auth_code': this.form.identifying
          })
            .then(response => {
              this.$router.push({ path: '/app/notice?mode=reset' })
            })
            .catch(error => {
              this.getIdentifying()
              this.identifying = ''
              if (error.response.data.errno === 233) {
                this.$router.push({ path: '/app/phone?token=0&email=' + this.form.email })
              }
            })
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.login-main {
  position: absolute;
  display: block;
  width: 420px;
  left: 50%;
  top: 15%;
  border: 1px solid #999;
  border-radius: 8px;
  margin-left: -210px;
  padding: 35px 60px 45px 60px;
}
.login-main img {
  display: block;
  width: 96px;
  margin: 0 auto;
  margin-bottom: 5px;
}
.identifying-main {
  width: 100%;
  height: 36px;
  overflow: hidden;
}
.identifying-img {
  margin-top: -8px;
  width: 100% !important;
}
.login-register {
  position: absolute;
  bottom: 15px;
  font-size: 15px;
  right: 50px;
  cursor: pointer;
  color: #20a0ff;
}
</style>
